import { jsxs as e, Fragment as t, jsx as o } from "react/jsx-runtime";

import i from "@ui-components-3/icons/lib/regular/CirclePlus";

import r from "@ui-components-3/ui/lib/components/Drawer";

import { useContext as n, useMemo as l } from "react";

import s from "@ui-components-3/ui/lib/utils/classNames";

import a from "@ui-components-3/ui/lib/components/Loading";

import { orderBy as c, groupBy as m } from "lodash";

import u from "./ScheduleItemCard.js";

import d from "../DrawerEmptyState.js";

import { useCreateAvailabilityFlow as p } from "../../../hooks/useCreateAvailability.js";

import { useProviderSchedule as f } from "../../../hooks/useProviderSchedule.js";

const h = {
    WEEKLY: "Recurring",
    DAILY: "Does not repeat"
}, b = () => {
    const {softClose: b} = n(r.context), {initFlow: y} = p(), {variantClassNames: g, schedules: x, isFetchingSchedules: N} = f(), v = l((() => x ? c(Object.entries(m(x, "frequency")).map((([e, t]) => ({
        title: h[e],
        data: t,
        frequency: e
    }))), [ "frequency" ], [ "desc" ]) : null), [ x ]);
    return e(t, {
        children: [ o(r.Content, {
            children: !v || !v.length && N ? o("div", {
                className: "flex items-center justify-center py-4",
                children: o(a, {
                    shown: !0
                })
            }) : e("div", {
                className: "flex flex-col gap-6 py-4",
                children: [ v.length ? o("div", {
                    className: "flex flex-col gap-4",
                    children: v.map((({title: t, frequency: i, data: r}) => e("div", {
                        className: "flex flex-col gap-3",
                        children: [ o("p", {
                            className: "typography-body-l font-semibold text-neutral-800",
                            children: t
                        }), r.map((e => o(u, {
                            schedule: e
                        }, e.id))) ]
                    }, i)))
                }) : o(d, {
                    description: "Manage your schedule by setting up slots of availability."
                }), e("button", {
                    type: "button",
                    className: s("btn", g.buttonOutlined),
                    onClick: () => y(),
                    children: [ o(i, {
                        "aria-hidden": "true"
                    }), "Add New" ]
                }) ]
            })
        }), o(r.Footer, {
            children: o("button", {
                type: "button",
                className: s("btn", g.buttonMain),
                onClick: b,
                children: "Done"
            })
        }) ]
    });
};

export { b as default };
//# sourceMappingURL=index.js.map
